var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticClass:"grid tt-bg-light"}),_c('Menu'),_c('Start',{attrs:{"countries":_vm.countries}}),_c('Tours'),_c('Become'),_c('Countries',{attrs:{"countries":_vm.countries.slice(0, 8)}}),_c('HowItWorks'),_c('Curator'),_c('TheArticle'),_c('Articles'),_c('Subscribe'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }